// Document Vault and client documents: the routes and the sidebar rows of `wealth.crm.document-vault` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.crm.document-vault',
    routes: [
        {
            frontend: 'ops',
            path: 'document-vault',
            lazy: () => import('@/pages/ops/document-vault/page'),
        },
    ],
    nav: [
        {
            frontend: 'ops',
            key: 'document-vault',
            label: 'Document Vault',
            href: '/ops/document-vault',
            icon: 'FileText',
            group: 'client-operations',
            order: 470,
        },
    ],
});
